import React, { useReducer } from "react";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import {
  formInitialState,
  formReducer,
} from "../../../../../reducers/formReducer";
import FormErrorMessage from "../../../../UI/errorMessages/FormErrorMessage";
import { Button } from "react-bootstrap";
import axios from "../../../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import CMSFormInput from "../../../../UI/forms/CMSFormInput";

const ChangeMemberEmailModal = ({
  memberId,
  initialValue,
  member,
  show,
  setShow,
  loadItem,
}) => {
  const [formState, formDispatch] = useReducer(formReducer, formInitialState);

  const handleClose = () => setShow(false);

  const onSubmit = async (data, resetForm) => {
    formDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(`members/change-member-email`, {
        id: memberId,
        email: data.email,
      });
      formDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      handleClose();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Action performed successfully.`,
        type: "success",
      });
      resetForm();
      formDispatch({
        type: "FORM_INITIAL_STAGE",
      });
      loadItem();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      formDispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: errorMessage,
      });
      setTimeout(() => {
        formDispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };

  return (
    <Formik
      initialValues={{
        email: "",
      }}
      validationSchema={yup.object({
        email: yup
          .string()
          .required("Required")
          .email()
          .notOneOf(
            [initialValue],
            "New email must be different from the current email",
          ),
      })}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        onSubmit(values, resetForm);
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose}>
          {formState.isFormSubmitting && (
            <div class="overlay">
              <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
            </div>
          )}
          <Form onSubmit={form.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Change Member Email Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="alert alert-warning" role="alert">
                By proceeding with this change, the member 
                <b>
                  {" "}{member.firstName} {member.lastName}'s{" "}
                </b>
                 existing official email address will be replaced. The previous
                email address will no longer be valid for login or for receiving
                communications.
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">
                  Current Email Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={initialValue}
                  disabled
                  readOnly
                />
              </div>

              <CMSFormInput
                name="email"
                label="New Email Address"
                required={true}
                form={form}
              />
              {formState.hasSubmissionError && (
                <FormErrorMessage error={formState.formSubmissionError} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

export default ChangeMemberEmailModal;
